import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import State from 'store/State';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';

export const buildSignalTileConfigSlice = (
    widgetType: WidgetType,
    selectWidgetState: (
        state: State,
        widgetKey: string
    ) => WidgetWithConfigState<SignalTileConfigState>,
    initialConfigState: SignalTileConfigState
) =>
    buildConfigSlice<SignalTileConfigState>(
        widgetType,
        selectWidgetState,
        initialConfigState
    );

export const useSignalTileConfigSlice = (
    widgetType: WidgetType,
    selectWidgetState: (
        state: State,
        widgetKey: string
    ) => WidgetWithConfigState<SignalTileConfigState>,
    initialConfigState: SignalTileConfigState
) =>
    useConfigSlice(
        buildSignalTileConfigSlice(
            widgetType,
            selectWidgetState,
            initialConfigState
        )
    );

export type SignalTileConfigPayloadType =
    WidgetConfigSliceActionPayloadType<SignalTileConfigState>;
